export const getDimensionFractions = () => [
  {
    value: 0,
    display: '0/0',
  },
  {
    value: 0.125,
    display: '1/8',
  },
  {
    value: 0.25,
    display: '1/4',
  },
  {
    value: 0.375,
    display: '3/8',
  },
  {
    value: 0.5,
    display: '1/2',
  },
  {
    value: 0.625,
    display: '5/8',
  },
  {
    value: 0.75,
    display: '3/4',
  },
  {
    value: 0.875,
    display: '7/8',
  },
];

export const getDimensionInches = (minValue, maxValue) => {
  const inches = [];
  for (let i = minValue; i < maxValue; i += 1) {
    inches.push({ value: i, display: i.toString() });
  }
  return inches;
};

export const getDimension = (inches, fraction) =>
  parseInt(inches) + parseFloat(fraction);

export const getDimensionAsString = (inches, fraction) => {
  const dimension = getDimension(inches, fraction);
  if (parseInt(dimension) === dimension) { return `${dimension.toString()}.0`; }
  return dimension.toString();
};
